import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Accordion from 'react-bootstrap/Accordion'
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Table from 'react-bootstrap/Table'
import { GiBulletBill } from 'react-icons/gi'
import { FiSave } from 'react-icons/fi'
import { IoIosAdd, IoIosWarning, IoIosStats } from 'react-icons/io'
import { TiUserDelete } from 'react-icons/ti'
import './index.css'
import '../main.css'
import { UpdateTeam, GetTeam, GetRiders, GetLeaguesByIds, GetMatchingTeams, GetDisabled, GetResults, GetEvents } from '../../ApiRequests'
import TeamPicker from "../TeamPicker/index";
import Helmet from 'react-helmet'


const EditTeam = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [leagueId, setLeagueId] = useState('')
    const [league, setLeague] = useState({})
    const [teamId, setTeamId] = useState('')
    const [riders, setRiders] = useState([])
    const [filteredRiders, setFilteredRiders] = useState(riders)
    const [userTeam, setUserTeam] = useState([])
    const [team, setTeam] = useState([])
    const [maleCount, setMaleCount] = useState(0)
    const [femaleCount, setFemaleCount] = useState(0)
    const [numMaleRiders, setNumMaleRiders] = useState(4)
    const [numFemaleRiders, setNumFemaleRiders] = useState(2)
    const [teamValue, setTeamValue] = useState(0)
    const [genderFilter, setGenderFilter] = useState('All')
    const [countryFilter, setCountryFilter] = useState('All')
    const [countries, setCountries] = useState([])

    const [fullTeam, setFullTeam] = useState({})
    const [matchingTeams, setMatchingTeams] = useState([])
    const [applyToTeams, setApplyToTeams] = useState([])
    const [showSaveTeam, setShowSaveTeam] = useState(false)
    const [editingDisabled, setEditingDisabled] = useState(false)
    const [showSaveTeamError, setShowSaveTeamError] = useState(false)
    const [events, setEvents] = useState([])
    const [event, setEvent] = useState({})

    const [pastResultRider, setPastResultRider] = useState({})
    const [showResultsModal, setShowResultsModal] = useState(false)

    const [results, setResults] = useState([])
    const [filteredResults, setFilteredResults] = useState([])
    const [genderResultFilter, setGenderResultFilter] = useState('m')
    const [pointsResultFilter, setPointsResultFilter] = useState('Overall')

    const params = new URLSearchParams(location.search);
    const _leagueId = params.get('leagueId');
    const _teamId = params.get('teamId');

    const riderIndex = filteredResults.findIndex(result => result.riderId === pastResultRider._id);

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    //Save the team 
    const saveTeam = async () => {
        const userId = localStorage.getItem('userID')
        const idArray = team.map(rider => rider._id);
        const teamIds = applyToTeams.map(_team => _team.teamId)
        teamIds.push(teamId)//Include the current team
        const data = {
            userId: userId,
            leagueId: leagueId,
            teamIds: teamIds,
            riders: idArray
        }

        const res = await UpdateTeam(data)

        if (res) {
            navigate(`/League?leagueId=${_leagueId}`)
        } else {
            setShowSaveTeam(false)
            setShowSaveTeamError(true)
        }
    }

    const addToTeam = async (rider) => {
        if (rider.gender == 'f' && femaleCount < numFemaleRiders) {
            // Add the female rider to the team
            setFemaleCount(femaleCount + 1);
            setTeamValue(teamValue + rider.value)
            setTeam(prevTeam => [...prevTeam, rider])
        } else if (rider.gender == 'm' && maleCount < numMaleRiders) {
            // Add the male rider to the team
            setMaleCount(maleCount + 1);
            setTeamValue(teamValue + rider.value)
            setTeam(prevTeam => [...prevTeam, rider])
        }
    }

    //Remove a rider from the team
    const removeFromTeam = (rider) => {
        if (rider.gender == 'f') {
            // Add the female rider to the team
            setFemaleCount(femaleCount - 1);
        } else if (rider.gender == 'm') {
            // Add the male rider to the team
            setMaleCount(maleCount - 1);
        }
        const updatedTeam = team.filter(r => r._id !== rider._id);
        setTeam(updatedTeam);
        setTeamValue(teamValue - rider.value)
    }

    //Get team from user
    const getTeam = async (id) => {
        const _teamData = await GetTeam(id)

        if (!_teamData) { return }
        if (!'data' in _teamData) {
            console.log('No data in team')
            return
        }

        setFullTeam(_teamData)
        const _team = _teamData.data
        setUserTeam(_team.riders)
        return _team
    }


    const getMatchingTeams = async (_team) => {
        const res = await GetMatchingTeams(_team)
        if (!res || !res.data) { return }

        setMatchingTeams(res.data)
    }


    //Gets the list of all riders
    const getRiders = async () => {
        const riders = await GetRiders()

        if (!riders) { return }
        if (riders.data.length == 0) { return }

        const sorted = [...riders.data].sort((a, b) => b.value - a.value);
        const _countries = [...new Set(riders.data.map(obj => obj.country))].sort((a, b) => a.localeCompare(b));

        setCountries(_countries)
        setRiders(sorted)
        setFilteredRiders(sorted)

        return sorted
    }

    const getRidersAndTeam = async (_teamId) => {
        const _riders = await getRiders()

        if (_teamId == '') { return }

        const _team = await getTeam(_teamId)

        if (!_team) { return }
        if (!'riders' in _team) { return }

        getMatchingTeams(_team)

        const _teamRiders = []

        //Match team rider Id's to riders array
        _team.riders.map((id, index) => {
            const _rider = _riders.find(rider => rider._id == id)
            const isInTeam = team.some((teamRider) => teamRider._id === _rider._id);

            if (_rider && !isInTeam) {
                _teamRiders.push(_rider)
            }
        })

        if (_teamRiders.length != 0) {
            setTeam(_teamRiders)
            getMaleFemaleCount(_teamRiders)
            getTeamValue(_teamRiders)
        }
    }

    const getTeamValue = (_team) => {
        if (!_team || _team.length === 0) {
            return 0; // Return 0 if the team is empty or undefined
        }

        const totalValue = _team.reduce((accumulator, rider) => accumulator + rider.value, 0);
        setTeamValue(totalValue)
        return totalValue;
    }

    const getMaleFemaleCount = (_teamRiders) => {
        if (!_teamRiders || _teamRiders.length === 0) {
            return 0; // Return 0 if the team is empty or undefined
        }
        const _femaleCount = _teamRiders.filter((rider) => rider.gender == 'f').length
        const _maleCount = _teamRiders.filter((rider) => rider.gender == 'm').length
        setFemaleCount(_femaleCount)
        setMaleCount(_maleCount)
    }


    const renderCountriesFilter = (country, index) => {
        return (
            <>
                <Dropdown.Item value={country} onClick={(e) => handleFilter(genderFilter, e.target.text)}>{country}</Dropdown.Item>
            </>
        )
    }

    const handleFilter = (genderValue, countryValue) => {
        setGenderFilter(genderValue)
        setCountryFilter(countryValue)

        if (genderValue === 'All' && countryValue === 'All') {
            setFilteredRiders(riders);
        } else {
            const genderFilter = genderValue === 'Male' ? 'm' : 'f';
            const filtered = riders.filter((rider) => {
                const isGenderMatch = genderValue === 'All' || rider.gender === genderFilter;
                const isCountryMatch = countryValue === 'All' || rider.country === countryValue;
                return isGenderMatch && isCountryMatch;
            });
            const sorted = [...filtered].sort((a, b) => b.value - a.value);
            setFilteredRiders(sorted);
        }
    }

    const getLeague = async () => {
        const res = await GetLeaguesByIds([_leagueId])

        try {
            if (!res || !res.data) { return }
            if (res.data.length == 0) { return }

            const _league = res.data[0]
            setLeague(_league)
            if (_league.numberMaleRiders != undefined || _league.numberMaleRiders != null) { setNumMaleRiders(_league.numberMaleRiders) }
            if (_league.numberFemaleRiders != undefined || _league.numberFemaleRiders != null) { setNumFemaleRiders(_league.numberFemaleRiders) }

        } catch (error) {
            console.log(error)
        }
    }

    const handleAddMatchingTeam = (e, _team) => {
        const isChecked = e.target.checked
        if (isChecked) {
            // Add the team object to the applyToTeams array
            setApplyToTeams((prevTeams) => [...prevTeams, _team]);
        } else {
            // Remove the team object from the applyToTeams array
            setApplyToTeams((prevTeams) =>
                prevTeams.filter((prevTeam) => prevTeam.leagueName !== _team.leagueName)
            );
        }
    }


    const getResults = async () => {
        const res = await GetResults();
        if (!res || !res.data) { return }

        const genderResultFilter = 'm';
        const sortedResults = res.data.sort((a, b) => b.total_points - a.total_points);
        setResults(sortedResults)

        const filtered = sortedResults.filter((result) => {
            const isGenderMatch = result.rider_gender === genderResultFilter;
            return isGenderMatch;
        });

        setFilteredResults([...filtered])
    }


    const handleResultsFilter = (genderValue, pointsFilter, event) => {
        setGenderResultFilter(genderValue)
        setPointsResultFilter(pointsFilter)

        const genderResultFilter = genderValue;
        const filtered = results.filter((result) => {
            const isGenderMatch = (genderValue === 'All' || result.rider_gender === genderResultFilter) && (result.eventId === event._id);
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        if (pointsFilter == 'Qualifying') {
            filteredAndSortedRiders.sort((a, b) => b?.qualifying_points - a?.qualifying_points);

        } else if (pointsFilter == 'Semis') {
            filteredAndSortedRiders.sort((a, b) => b?.semis_points - a?.semis_points);

        } else if (pointsFilter == 'Finals') {
            filteredAndSortedRiders.sort((a, b) => b?.finals_points - a?.finals_points);

        } else if (pointsFilter == 'Overall') {
            filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        }

        setFilteredResults(filteredAndSortedRiders);
    }

    const getEvents = async () => {
        const res = await GetEvents()

        if (!res || !res.data) { return }
        setEvents(res.data)
        setEvent(res.data[0])
    }


    const handlePastResults = (rider) => {
        setPastResultRider(rider)
        setShowResultsModal(true)
    }

    useEffect(() => {
        setLeagueId(_leagueId)
        setTeamId(_teamId)
        setGenderFilter('All')
        getRidersAndTeam(_teamId)
        getTeamValue()
        getLeague()
        getEditingDisabled()
        getResults()
        getEvents()
    }, []);

    const renderMatchingTeams = (_team, index) => {
        if (_team.leagueName != league.name)
            return (<>
                <Form.Check label={_team.leagueName} className="fw-light"
                    checked={applyToTeams.some((matchingTeam) => matchingTeam.leagueName == _team.leagueName)}
                    onChange={(e) => { handleAddMatchingTeam(e, _team) }}>
                </Form.Check>
            </>)
    }

    const renderRiders = (rider, index) => {

        const isInTeam = team.some((teamRider) => teamRider._id === rider._id);
        const teamFull = (Array.isArray(team) && team.length == 6)
        const teamValueLimit = rider.value + teamValue > 30 ? true : false
        const femaleCountFull = femaleCount >= numFemaleRiders ? true : false
        const maleCountFull = maleCount >= numMaleRiders ? true : false

        let riderDisabled = false
        if (isInTeam || teamFull || teamValueLimit || (rider.gender == 'f' && femaleCountFull) || (rider.gender == 'm' && maleCountFull)) {
            riderDisabled = true
        }

        return (
            <div >
                <Card className="my-2" bg='light' >
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider?.first_name} </span>{rider?.last_name}<span className="fw-light fs-6 ms-1">({rider?.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 align-items-center fw-light hidden-mobile">{rider?.team && rider?.team.split(" ")[0]}</div>
                            <div className="col-sm fs-6 align-items-center fw-light hidden-mobile">{rider?.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light justify-content">${(rider?.value * 50000).toLocaleString()}</div>
                            <div className="col-sm w-100 fs-6 d-flex align-items-center fw-light flex-row justify-content-center">
                                <Button className="w-100 my-sm-0 my-2" variant="outline-primary" onClick={() => { setGenderResultFilter(rider.gender); handlePastResults(rider); handleResultsFilter(rider.gender, pointsResultFilter, event) }}><IoIosStats size={20} className="mb-1 me-2"></IoIosStats>Past Results</Button>
                            </div>
                            <div className="col-sm w-100 fs-6 d-flex align-items-center fw-light flex-row justify-content-end">
                                {riderDisabled ? <Button className="w-100" disabled variant="outline-secondary" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button> : <Button className="w-100" variant="dark" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const renderTeam = (rider, index) => {
        return (
            <div>
                <Card className="my-2" bg='light'>
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name} <span className="fw-light fs-6 ms-1">({rider.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 align-items-center fw-light hidden-mobile">{rider.team}</div>
                            <div className="col-sm fs-6 align-items-center fw-light hidden-mobile">{rider.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">${(rider.value * 50000).toLocaleString()}</div>
                            <div className="col-sm w-100 fs-6 d-flex align-items-center fw-light flex-row justify-content-center">
                                <Button className="w-100 my-sm-0 my-2" variant="outline-primary" onClick={() => { setGenderResultFilter(rider.gender); handlePastResults(rider); handleResultsFilter(rider.gender, pointsResultFilter, event) }}><IoIosStats size={20} className="mb-1 me-2"></IoIosStats>Past Results</Button>
                            </div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light d-flex flex-row justify-content-end">
                                <Button className="w-100" variant="outline-danger" onClick={() => removeFromTeam(rider)}><TiUserDelete size={20} className="mb-1 me-2"></TiUserDelete>Remove</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }


    const renderResult = (result, index, type) => {
        let points = 0;
        switch (type) {
            case 'Overall':
                points = result.total_points;
                break;
            case 'Qualifying':
                points = result.qualifying_points;
                break;
            case 'Semis':
                points = result.semis_points;
                break;
            case 'Finals':
                points = result.finals_points;
                break;
            default:
                points = 0;
        }


        return (
            <>
                {
                    result.riderId == pastResultRider._id &&
                    result.eventId == event._id &&
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{points == 0 ? '-' : index}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        {type == 'Overall' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>}
                        {type == 'Qualifying' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.finals_points}</td>}
                    </tr>
                }
            </>
        )
    }


    return (
        <div className="container pt-3" style={{ backgroundColor: 'white' }}>
            <Helmet>
                <title>Edit Team - Downhill MTB Fantasy</title>
                <meta name="description" content="Edit your existing fantasy team for the downhill mountain biking league. Make changes to your rider selections and optimize your team's performance." />
            </Helmet>
            <div className="px-3 pb-1 transition">
                <div className=" mt-2 d-flex flex-row justify-content-sm-center fw-bold fs-4 ">{league?.name}</div>
                <div className="mb-2 d-flex flex-row justify-content-sm-center fw-light fs-6 ">{league?.description}</div>
                <div className="my-3"> <span className="fw-bold">Rules: </span>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> You may edit your team as many times as you would like.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Team editing is locked 24 hours before next event qualifying date.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> You have $1,500,000 to spend. </div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Select {numFemaleRiders} Female Riders. </div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Select {numMaleRiders} Male Riders. </div>
                </div>
                <Accordion defaultActiveKey={'0'} alwaysOpen>
                    <Accordion.Item eventKey="0" >
                        <Accordion.Header>
                            <div className="row w-100">
                                <div className="col-sm-6">
                                    {Array.isArray(team) ?
                                        <div className="h4">Selected {team.length} of 6 riders</div> : <div className="h4">Select 6 riders</div>
                                    }
                                </div>
                                <div className="col-sm-6 d-flex flex-row justify-content-end pe-5">
                                    <div className="h4">Remaining: ${((30 - teamValue) * 50000).toLocaleString()}</div>
                                </div>
                            </div>

                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-sm-2 fw-light">Female riders: {femaleCount}/{numFemaleRiders}</div>
                                <div className="col-sm-2 fw-light">Male riders: {maleCount}/{numMaleRiders}</div>
                            </div>
                            <div className="">
                                {Array.isArray(team) && team.map(renderTeam)}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="d-flex flex-row justify-content-end pt-3">
                    <Button disabled={editingDisabled || teamValue > 30 || (Array.isArray(team) && team.length < 6) || (maleCount != numMaleRiders || femaleCount != numFemaleRiders)} onClick={() => setShowSaveTeam(true)}><FiSave size={20} className="mb-1 me-2"></FiSave>Save Team</Button>
                </div>
            </div>
            <hr></hr>
            <div className="px-3 py-2 transition">
                <div className="row mb-3">
                    <div className="col-lg-1 h4 me-lg-4">Riders</div>
                    {/* <div className="col-md-1 fw-light d-flex flex-row align-items-center justify-content-md-end">Filters:</div> */}
                    <div className="col-lg-1 d-flex align-items-center fw-light justify-content-lg-end">Gender:</div>
                    <div className="col-lg-1 d-flex flex-row justify-content-start">
                        <DropdownButton onChange={(e) => handleFilter(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={genderFilter} className="">
                            <Dropdown.Item value='All' onClick={(e) => handleFilter(e.target.text, countryFilter)}>All</Dropdown.Item>
                            <Dropdown.Item value='Male' onClick={(e) => handleFilter(e.target.text, countryFilter)}>Male</Dropdown.Item>
                            <Dropdown.Item value='Female' onClick={(e) => handleFilter(e.target.text, countryFilter)}>Female</Dropdown.Item>
                        </DropdownButton>
                    </div>
                    <div className="col-lg-1 d-flex align-items-center fw-light justify-content-lg-end">Country:</div>
                    <div className="col-lg d-flex flex-row justify-content-start">
                        <DropdownButton onChange={(e) => console.log(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={countryFilter} className="">
                            <Dropdown.Item value='All' onClick={(e) => handleFilter(genderFilter, 'All')}>All</Dropdown.Item>
                            {Array.isArray(countries) && countries.map(renderCountriesFilter)}
                        </DropdownButton>
                    </div>
                </div>
                {Array.isArray(filteredRiders) && filteredRiders.map(renderRiders)}
            </div>


            <Modal size='lg' show={showSaveTeam} onHide={() => setShowSaveTeam(false)}>
                <Modal.Header closeButton>
                    <FiSave size={24} className="me-2"></FiSave>
                    <Modal.Title>Save Team</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="fw-light">Would you like to apply these changes to your team in any of the following leagues? </Form.Label>
                    <Form.Label className="fw-lighter">Note: The leagues listed below have a matching amount of male and female riders.</Form.Label>
                    {Array.isArray(matchingTeams) && matchingTeams.map(renderMatchingTeams)}
                    {Array.isArray(matchingTeams) && matchingTeams.length <= 1 && <div className="mx-5 mt-4" style={{ color: 'red' }}>**No teams found with matching parameters</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="px-4" onClick={() => setShowSaveTeam(false)}>
                        Close
                    </Button>
                    <Button variant="primary" className="px-4" onClick={() => saveTeam()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal size='md' show={showSaveTeamError} onHide={() => setShowSaveTeamError(false)}>
                <Modal.Header closeButton>
                    <IoIosWarning size={24} className="me-2"></IoIosWarning>
                    <Modal.Title>Could not save team. </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="fw-light">If an event is currently underway, team editing is temporarily locked. Please check back after the event has concluded to make any changes. If the event is upcoming, please ensure that you have a complete team of riders before proceeding with the edits. </Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="px-4" onClick={() => setShowSaveTeamError(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal size='lg' show={showResultsModal} onHide={() => setShowResultsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Results for Rider: {pastResultRider.first_name} {pastResultRider.last_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row my-2 mb-3">
                        <div className="col-sm-1 me-4 d-flex align-items-center">Event:</div>
                        <div className="col-sm d-flex justify-content-start">
                            <DropdownButton size='md' className="" onChange={(e) => handleResultsFilter(genderResultFilter, pointsResultFilter, e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={event?.location} >
                                {Array.isArray(events) && events.map((_event, index) => <Dropdown.Item value={_event} onClick={(e) => { setEvent(_event); handleResultsFilter(genderResultFilter, pointsResultFilter, _event) }}>{_event.location}</Dropdown.Item>)}
                            </DropdownButton>
                        </div>
                    </div>


                    <Tabs
                        defaultActiveKey="Overall"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={(e) => handleResultsFilter(genderResultFilter, e, event)}
                    >
                        <Tab eventKey="Overall" title="Overall">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResult(result, riderIndex + 1, 'Overall'))}
                                </tbody>
                            </Table>

                        </Tab>
                        <Tab eventKey="Qualifying" title="Qualifying">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResult(result, riderIndex + 1, 'Qualifying'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Semis" title="Semi Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResult(result, riderIndex + 1, 'Semis'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Finals" title="Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResult(result, riderIndex + 1, 'Finals'))}
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowResultsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default EditTeam;